import React, { useContext, useMemo } from 'react'
import { useSelector } from 'react-redux'

import StepForm from '../../../../../../features/components/Forms/StepForm'
import NameStep from '../Steps/NameStep'
import TextStep from '../Steps/TextStep'
import FacebookPageStep from '../Steps/FacebookPageStep'
import StatusStep from '../Steps/StatusStep'
import CarouselMediaStep from '../Steps/CarouselMediaStep'
import UrlTagsStep from '../Steps/UrlTagsStep'
import WarningStep from '../Steps/WarningStep'
import InstantFormSelectionStep from '../Steps/InstantFormSelectionStep'

import { useCreateFacebookAd } from '../hooks/useCreateFacebookAd'
import getShowUrlTagsStep from '../helpers/getShowUrlTagsStep'
import { AdFacebookCreateContext } from '../../../../formsContexts/AdFacebookCreateFormContextProvider'

import { accessibleSocialPagesSelector } from '../../../../../../modules/selectors/socialAccounts'

import { LEAD_GENERATION } from '../../../../../../constants/campaigns'
import { FORMAT_CAROUSEL } from '../../../fields'

const MultipleMediaFileRoute = ({
  FormRouteSelector,
  eventSourceStep,
  isInternalAdCreation,
  selectedApplicationId,
  selectedPixelPassedFromOutside,
  allowSendPixel,
  ...formProps
}) => {
  const { isAdSetEndDateInThePast, showAsStory, purifiedFormik, isDomainValidating } = useCreateFacebookAd({
    isInternalAdCreation,
    selectedApplicationId,
    selectedPixelPassedFromOutside,
    allowSendPixel,
    formatOption: FORMAT_CAROUSEL
  })

  const facebookPages = useSelector(accessibleSocialPagesSelector)

  const { lineItem } = useContext(AdFacebookCreateContext)
  const { objective: lineItemObjective } = lineItem

  const { values } = purifiedFormik
  const showUrlTagsStep = getShowUrlTagsStep(values)

  const steps = useMemo(
    () => [
      {
        component: <WarningStep />,
        show: isAdSetEndDateInThePast
      },
      {
        component: FormRouteSelector,
        show: !showAsStory
      },
      {
        component: <NameStep />,
        show: true
      },
      {
        component: <FacebookPageStep />,
        show: facebookPages.length !== 1
      },
      {
        component: <InstantFormSelectionStep />,
        show: lineItemObjective === LEAD_GENERATION
      },
      {
        component: <TextStep />,
        show: true
      },
      {
        component: <CarouselMediaStep />,
        show: true
      },
      eventSourceStep,
      {
        component: <UrlTagsStep selectedApplicationId={selectedApplicationId} />,
        show: showUrlTagsStep
      },
      {
        component: <StatusStep />,
        show: true
      }
    ],
    [
      eventSourceStep,
      FormRouteSelector,
      showAsStory,
      isAdSetEndDateInThePast,
      facebookPages,
      showUrlTagsStep,
      lineItemObjective,
      selectedApplicationId
    ]
  )

  return <StepForm steps={steps} formik={purifiedFormik} {...formProps} isSubmitDataLoading={isDomainValidating} />
}

export default MultipleMediaFileRoute
